@let item = movement();

<card
  [variant]="item.kind === 'purchase' ? 'success' : 'danger'"
  [accentBar]="true"
  class="flex min-h-[74px] items-center justify-between gap-2"
  [attr.data-test]="'movement-' + item.kind">
  <div class="min-w-0">
    <p class="text-body font-medium">{{ item.title }}</p>

    <p class="text-label text-blue-frost mt-1 flex items-center gap-2">
      {{ item.date | date: 'd MMM y' }}
      <span
        aria-hidden="true"
        class="bg-blue-frost size-[3px] rounded-full"></span>
      {{ item.status }}
    </p>
  </div>

  @switch (item.kind) { @case ('purchase') {
  <p class="text-status-green flex shrink-0 flex-col items-end leading-none">
    <span class="text-card-title font-bold">+ {{ item.amount | number: '1.0-1' }}</span>
    <span class="text-caption mt-1 font-medium">botellas</span>
  </p>
  } @case ('redemption') {
  <p class="text-card-title text-action-red flex shrink-0 items-center gap-1 font-bold">
    −

    <img
      ngSrc="https://superlikers-themes.s3.us-east-1.amazonaws.com/pernod2/coin.png"
      width="30"
      height="34"
      alt="monedas" />

    {{ item.amount | number }}
  </p>
  } @case ('rejected') { @if (item.image) {
  <button
    type="button"
    class="text-label decoration-action-red shrink-0 font-bold text-white underline decoration-2 underline-offset-4"
    data-test="movement-image"
    (click)="openImage()">
    Ver imagen
  </button>
  } @else {
  <icon
    name="circle-x"
    class="text-action-red shrink-0"
    [size]="24" />
  } } }
</card>
